// Generate a single sample from a standard normal distribution
// (mean zero, sigma 1).
function normal(mean: number, sigma: number) {
  // Use the Marsaglia Polar method
  let s;
  let u;
  let v;

  do {
    // U and V are from the uniform distribution on (-1, 1)
    u = (Math.random() * 2) - 1;
    v = (Math.random() * 2) - 1;

    s = (u * u) + (v * v);
  } while (s >= 1);

  // Compute the standard normal variate
  const norm = u * Math.sqrt(-2 * Math.log(s) / s);

  // Shape and scale
  return (sigma * norm) + mean;
}

export class NormalDist {
  static deserialize(s: string): NormalDist {
    const j = JSON.parse(s) as Record<string, number>;

    return new NormalDist(
      j.mean,
      j.stddev,
    );
  }

  _mean: number;
  _stddev: number;

  constructor(
    mean: number,
    stddev: number,
  ) {
    this._mean = mean;
    this._stddev = stddev;
  }

  serialize(): string {
    return JSON.stringify({
      mean: this.mean,
      stddev: this.stddev,
    });
  }

  get mean(): number {
    return this._mean;
  }

  get stddev(): number {
    return this._stddev;
  }

  sample(): number {
    return (this._stddev === 0)
      ? this._mean
      : normal(this._mean, this._stddev);
  }
}
